import Vue from "vue";
import { TypePageErreur } from "../../shared/models/typePageErreur";
import Component from "vue-class-component";

@Component
export default class ErreurEcran extends Vue {
	public errorMessage = "";

	public mounted(): void {
		switch (Number(this.$route.params.id)) {
			case TypePageErreur.SSO:
				this.errorMessage = "Vous n'êtes pas autorisé à vous connecter.<br/> Rapprochez-vous de votre administrateur afin qu'il associe votre compte SSO à votre profil salarié afin de vous donner les accès..";
				break;
			case TypePageErreur.ListeSocietes:
				this.errorMessage = "Vous n'avez pas de contrat actif, veuillez vous rapprocher de votre gestionnaire de paie.";
				break;
			default:
				this.errorMessage = "Une erreur est survenue, veuillez vous rapprocher de votre gestionnaire de paie.";
				break;
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/ecranErreur/erreurEcran.ts